import React, { forwardRef } from 'react';
import { useFormControl } from '../Form';
import { ScopedCssBaseline, FocusStyle } from '../StyleBase';
import styled, { css } from 'styled-components';
const Control = styled.div.withConfig({
  displayName: "InputControl__Control",
  componentId: "sc-v61bhm-0"
})(["", " ", " display:flex;padding:var(--size-spacing-02) var(--size-spacing-03);background:var(--neutral-surface);border:1px solid var(--neutral-border-interactive);border-radius:var(--border-radius-rounded);height:40px;width:100%;&:hover,&:focus-within{border-color:var(--neutral-border-interactive-hover);}", " ", " ", ""], ScopedCssBaseline, FocusStyle, _ref => {
  let {
    error
  } = _ref;
  return error && css(["&,&:hover{border-color:var(--danger-border);}&:focus-within,&:hover:focus-within{border-color:var(--neutral-border-interactive-hover);}"]);
}, _ref2 => {
  let {
    success
  } = _ref2;
  return success && css(["&,&:hover{border-color:var(--success-border);}&:focus-within,&:hover:focus-within{border-color:var(--neutral-border-interactive-hover);}"]);
}, _ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled && css(["background:var(--neutral-surface-disabled);&,&:hover,&:focus,&:focus-within,&:hover:focus,&:hover:focus-within{border-color:var(--neutral-border-interactive-disabled);}"]);
});
/**
 * @ignore - do not document.
 */

const InputControl = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    className,
    style,
    error,
    success,
    disabled,
    onClick,
    children
  } = _ref4;
  const {
    error: errorFormControl,
    success: successFormControl
  } = useFormControl();
  const isSuccess = successFormControl || success;
  const isError = errorFormControl || error;
  return /*#__PURE__*/React.createElement(Control, {
    error: isError,
    success: isSuccess,
    disabled: disabled,
    onClick: onClick,
    ref: ref,
    className: className,
    style: style
  }, children);
});
export default InputControl;
InputControl.displayName = 'InputControl';